import produce from 'immer';

import {
  GET_CLIENTS_FAILURE, GET_CLIENTS_REQUEST, GET_CLIENTS_SUCCESS,
  GET_RELOCATION_CONSULTANTS_FAILURE, GET_RELOCATION_CONSULTANTS_REQUEST, GET_RELOCATION_CONSULTANTS_SUCCESS,
} from './types';
import { remapClients, remapUsers } from './utils';

const initialState = {
  clients: null,
  users: null,
  isLoading: false,
};

export default produce((draft = initialState, action) => {
  switch (action.type) {
    case GET_CLIENTS_REQUEST:
    case GET_RELOCATION_CONSULTANTS_REQUEST:
      draft.isLoading = true;
      break;

    case GET_CLIENTS_FAILURE:
    case GET_RELOCATION_CONSULTANTS_FAILURE:
      draft.isLoading = false;
      break;

    case GET_CLIENTS_SUCCESS:
      draft.clients = remapClients(action.response);
      draft.isLoading = false;
      break;

    case GET_RELOCATION_CONSULTANTS_SUCCESS:
      draft.relocationConsultants = remapUsers(action.response);
      draft.isLoading = false;
      break;

    default:
      break;
  }

  return draft;
}, initialState);
